'use client'
import React, { useState } from 'react';
import Head from 'next/head'
import Image from 'next/image'
import Link from 'next/link';
import NavBarLanding from '@/components/NavBarLanding';
import Footer from '@/components/Footer';
import { SignFrom } from '@/components/Sign';
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion"

export default function Faq() {
    const [signValue, setSignValue] = useState<string>('signup');
    const [toggleSignForm, setToggleSignForm] = useState<boolean>(false);


    return (
        <>
            <Head>
                <title>Eurekia !</title>
                <meta name="description" content="Generated by webzh" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="icon" href="/favicon.ico" />
            </Head>

            <main className="w-full items-center justify-center flex-col bg-main overflow-x-hidden relative gap-4">
                {
                    toggleSignForm ?

                        <div className='w-full sm:h-full h-screen flex justify-center items-center'>
                            <style global jsx>{`
    #__next {
        height:100vh;
        width:100vw;
        overflow:hidden
      }
`}</style>
                            <div onClick={() => setToggleSignForm(false)} className='z-50 w-full h-full fixed top-0 left-0 flex justify-center items-center backdrop-blur-md bg-black bg-opacity-10'>
                            </div>
                            <div className='z-[1000] fixed flex justify-center'>
                                <SignFrom signValue={signValue} />
                            </div>
                        </div>
                        : null
                }
                < NavBarLanding
                    signValue={signValue as string}
                    setSignValue={setSignValue}
                    toggleSignForm={toggleSignForm}
                    setToggleSignForm={setToggleSignForm}
                />
                <section className="w-full flex flex-col items-center h-auto pt-[150px]">

                    <h1 className='font-medium text-3xl lg:text-[2.4vw] leading-tight flex sm:items-start items-center justify-center flex-col text-center'>
                        Foire au questions
                    </h1>
                    <div className=" p-8 w-full max-w-[1280px] mx-auto rounded shadow-lg">
                        <Accordion type="single" collapsible>
                            <AccordionItem value="item-1">
                                <AccordionTrigger>Comment sont calculés les crédits pour l'utilisation de GPT3.5 et GPT4 ?</AccordionTrigger>
                                <AccordionContent>
                                    Les crédits sont déduits en fonction du modèle que vous utilisez. Pour GPT3.5, chaque tranche d'environ 30 000 mots consomme 1000 crédits. Pour GPT4, 1000 crédits représente environ 1200 mots.
                                </AccordionContent>
                            </AccordionItem>

                            <AccordionItem value="item-2">
                                <AccordionTrigger>Combien coûte la génération d'une image par IA en termes de crédits ?</AccordionTrigger>
                                <AccordionContent>
                                    Chaque image générée par notre IA consomme 900 crédits.
                                </AccordionContent>
                            </AccordionItem>

                            <AccordionItem value="item-3">
                                <AccordionTrigger>Est-il possible de suivre la consommation de mes crédits en temps réel ?</AccordionTrigger>
                                <AccordionContent>
                                    Oui, vous pouvez consulter votre consommation de crédits à tout moment depuis votre tableau de bord. Sinon, cette fonctionnalité n'est pas disponible, mais nous travaillons à son intégration.
                                </AccordionContent>
                            </AccordionItem>

                            <AccordionItem value="item-4">
                                <AccordionTrigger>Qu'advient-il si j'épuise tous mes crédits avant la fin du mois ?</AccordionTrigger>
                                <AccordionContent>
                                    Si vous épuisez vos crédits, vous aurez la possibilité d'acheter des crédits supplémentaires ou d'attendre le prochain cycle de facturation pour que vos crédits soient rechargés.
                                </AccordionContent>
                            </AccordionItem>
                            <AccordionItem value="item-5">
                                <AccordionTrigger>Quelle est la différence entre GPT3.5 et GPT4 en termes de qualité et de coût ?</AccordionTrigger>
                                <AccordionContent>
                                    GPT4 est une version plus avancée et offre généralement des résultats de meilleure qualité par rapport à GPT3.5. Cependant, l'utilisation de GPT4 est plus économique en termes de crédits par mot par rapport à GPT3.5.
                                </AccordionContent>
                            </AccordionItem>

                            <AccordionItem value="item-6">
                                <AccordionTrigger>Puis-je changer mon plan d'abonnement à tout moment ?</AccordionTrigger>
                                <AccordionContent>
                                    Oui, vous pouvez modifier votre plan d'abonnement à tout moment. Si vous effectuez un changement, la facturation sera ajustée en conséquence lors du prochain cycle de facturation.
                                </AccordionContent>
                            </AccordionItem>

                            <AccordionItem value="item-7">
                                <AccordionTrigger>Comment fonctionne la période d'essai de 7 jours ?</AccordionTrigger>
                                <AccordionContent>
                                    La période d'essai vous permet de tester nos services pendant une semaine sans frais. Si vous décidez de ne pas continuer après la période d'essai, votre abonnement sera résilié sans frais supplémentaires.
                                </AccordionContent>
                            </AccordionItem>

                            <AccordionItem value="item-8">
                                <AccordionTrigger>Qu'advient-il si je souhaite annuler mon abonnement ?</AccordionTrigger>
                                <AccordionContent>
                                    Vous pouvez annuler votre abonnement à tout moment. L'annulation prendra effet à la fin de votre cycle de facturation actuel, et il n'y aura pas de prélèvement supplémentaire.
                                </AccordionContent>
                            </AccordionItem>

                            <AccordionItem value="item-9">
                                <AccordionTrigger>Y a-t-il des restrictions sur l'utilisation de mes crédits ?</AccordionTrigger>
                                <AccordionContent>
                                    Les crédits sont conçus pour être déduits selon votre utilisation des services, comme la génération de texte ou d'images. Toutefois, une utilisation excessive en très peu de temps pourrait entraîner des restrictions temporaires pour garantir une expérience équitable pour tous les utilisateurs.
                                </AccordionContent>
                            </AccordionItem>

                            <AccordionItem value="item-10">
                                <AccordionTrigger>*Est-ce que le plan premium offre un accès illimité à toutes les fonctionnalités de l'app ?</AccordionTrigger>
                                <AccordionContent>
                                    Avec le plan premium, vous bénéficiez d'un accès illimité au moteur d'intelligence artificielle GPT-3.5 pour toutes les fonctionnalités de l'application. Cependant, il est important de noter que le chat avec PDF n'est pas inclus dans cette offre illimitée. Pour cette fonction spécifique, des limitations peuvent s'appliquer. Nous vous recommandons de consulter les détails du plan premium pour en savoir plus sur les spécificités de cette offre.                                </AccordionContent>
                            </AccordionItem>
                        </Accordion>
                    </div>
                </section>
                <Footer />

            </main>
        </>
    )
}
